import React from 'react';
import { Box } from '@mui/material';

const PublicLayout = ({ children }) => {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {children}
    </Box>
  );
};

export default PublicLayout; 